import { configureStore } from '@reduxjs/toolkit';
import axios from 'axios';
import {
  persistStore, persistReducer,
  FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER
} from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { BASE_URL } from '../Components/common/constants';
// import { clearSession } from '../utilities';
import { rootReducer } from './slices';
// import logger from "react-logger"


// creating and persisting redux store
const persistConfig = { key: 'root', storage };

const persistedReducer = persistReducer(persistConfig, rootReducer)

export const store = configureStore({
  reducer: persistedReducer,

  // Restrict Redux Devtool in Production
  devTools: process.env.NODE_ENV !== "production",
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types
        ignoredActions: ['persist/PERSIST', FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
        // Ignore these field paths in all actions
        ignoredActionPaths: ['meta.arg', 'payload.timestamp'],
        // Ignore these paths in the state
        ignoredPaths: ['items.dates'],
      },
    }),

});

export const persistor = persistStore(store);

// ------------------------ axios interceptor request -------------------------
axios.interceptors.request.use((request) => {
  let accessToken = typeof window !== "undefined" ? window.localStorage.getItem("token") : null;
  let UTCOffset = new Date().getTimezoneOffset();
 
  if(accessToken){
    request.headers.set('authorization', accessToken)
    if (typeof window.chrome != 'undefined' && window?.chrome?.storage !== undefined) {
      // If there is an access token present
      window?.chrome.storage.local.set({ accessToken: accessToken }, function () {
      });
    }
  }
    
  request.headers.set('utcoffset' , UTCOffset)
  request.headers.set('language' , "en")
  request.headers.set('Cache-Control', 'no-cache')
  request.baseURL = BASE_URL
 
  return request;
},
  (error) => {
    return Promise.reject(error);
  }
);

// ------------------------ axios interceptor response -------------------------
axios.interceptors.response.use((response) => {
  return response;
},
  (error) => {
    switch (error.response?.status) {
      case 401:
        // clearSession();
        break;
      case 400:
        // toast.error(error.response.data.message);
        break;
      default:
        break;
      // toast.error('Something really went wrong, please try again');
    }
    return Promise.reject(error);
  }
);


